import { Cascader, Col, Input, Row, Table, Tag, message } from "antd";
import React, { useState } from "react";
import { useLocation,Link } from "react-router-dom";


const ListworkloadIdentites = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [filterBy, setfilterBy] = useState("");
  const [filteredValue, setFilteredValue] = useState("");
  const [totalCount, setTotalCount] = useState(1);
  const [search, setSearch] = useState("");
  const [notification, setNotification] = message.useMessage();
  const [endpoint, setEndpoint] = useState([]);
  const [endpointUser, setEndpointUser] = useState([]);
  const [paginationParams, setPaginationParams] = useState({
    currentPage: 1,
    pageSize: 10,
  });
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const epmUsername = queryParams.get("epmUser");
  

  const columns = [
    {
      title: "Workload Identity Name",
      dataIndex: "Identity",
      key: "Identity",
    },
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Identity Group",
      dataIndex: "Group",
      key: "Group",
    },
    {
      title: "Can access",
      dataIndex: "access",
      key: "access",
      
      
    },
    {
      title: "Created by",
      dataIndex: "Created",
      key: "Created",
     
    },
    {
        title: "Rules",
        dataIndex: "rule",
        key: "rule",
        
      },
      {
        title: "History",
        dataIndex: "history",
        key: "history",
       
      },
  ];

  const dataSource = [
    {
      key: '1',
      Identity: 'Authnull-admin',
      id: '3C12Y-QACR-9IOP',
      Group: <Tag color="blue">Endpoint Group #1</Tag>,
      access: [<Tag color="blue">Endpoint Group #17</Tag>,
      <Tag color="blue">Endpoint Group #21</Tag>,], 
    
      
      Created: 'asif@authnull.com',
      rule: <Link to={`/workloadIdentity/workloadDyanamicAuthz`}>View Rules</Link>,
      history: <Link to={`/workloadIdentity/addWorkloadIdentity`}>View history</Link>,
      
    },
    {
        key: '2',
        Identity: 'Authnull-admin',
        id: '3C12Y-QACR-9IOP',
        Group: <Tag color="blue">Endpoint Group #1</Tag>,
        access: [<Tag color="blue">Endpoint Group #17</Tag>,
        <Tag color="blue">Endpoint Group #21</Tag>,], 
        Created: 'asif@authnull.com',
        rule: <Link to={`/workloadIdentity/workloadDyanamicAuthz`}>View Rules</Link>,
        history: <Link to={`/workloadIdentity/addWorkloadIdentity`}>View history</Link>,
        
      },
      {
        key: '3',
        Identity: 'Authnull-admin',
        id: '3C12Y-QACR-9IOP',
        Group: <Tag color="blue">Endpoint Group #1</Tag>,
        access: [<Tag color="blue">Endpoint Group #17</Tag>,
        <Tag color="blue">Endpoint Group #21</Tag>,], 
        Created: 'asif@authnull.com',
        rule: <Link to={`/workloadIdentity/workloadDyanamicAuthz`}>View Rules</Link>,
        history: <Link to={`/workloadIdentity/addWorkloadIdentity`}>View history</Link>,
        
      },
      {
        key: '4',
        Identity: 'Authnull-admin',
        id: '3C12Y-QACR-9IOP',
        Group: <Tag color="blue">Endpoint Group #1</Tag>,
        access: [<Tag color="blue">Endpoint Group #17</Tag>,
        <Tag color="blue">Endpoint Group #21</Tag>,], 
        Created: 'asif@authnull.com',
        rule: <Link to={`/workloadIdentity/workloadDyanamicAuthz`}>View Rules</Link>,
        history: <Link to={`/workloadIdentity/addWorkloadIdentity`}>View history</Link>,
        
      },
      {
        key: '5',
        Identity: 'Authnull-admin',
        id: '3C12Y-QACR-9IOP',
        Group: <Tag color="blue">Endpoint Group #1</Tag>,
        access: [<Tag color="blue">Endpoint Group #17</Tag>,
        <Tag color="blue">Endpoint Group #21</Tag>,], 
        Created: 'asif@authnull.com',
        rule: <Link to={`/workloadIdentity/workloadDyanamicAuthz`}>View Rules</Link>,
        history: <Link to={`/workloadIdentity/addWorkloadIdentity`}>View history</Link>,
        
      },
    
  ];

  const displayRender = (labels) => labels[labels.length - 1];
  const filter = (inputValue, path) =>
    path.some((option) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);

  const handleFilter = (_, data) => {
    setfilterBy(data ? data[0]?.value : "");
    setFilteredValue(data ? data[1]?.label : "");
  };
  const option = [
    {
      value: "IDENTITYNAME",
      label: "Identity Name",
      children: endpoint,
    },
    {
      value: "IDENTITYGROUP",
      label: "Identity Group",
      children: endpointUser,
    },
  ];

 
  return (
    <>
      {setNotification}
      <Row className="content-conatiner">
        <Col span={24}>
          <Row>
            <Col span={24}>
              <Row className="search-box-container">
                <Col span={6}>
                  <p className="search-label">Filter by</p>
                  <div>
                    <Cascader
                      options={option}
                      expandTrigger="hover"
                      displayRender={displayRender}
                      onChange={handleFilter}
                      placeholder="Search to select"
                      showSearch={{
                        filter,
                      }}
                    />
                  </div>
                </Col>
                <Col span={6}>
                  <p className="search-label">Search</p>
                  <div>
                    <Input
                      placeholder="Search"
                      allowClear
                      onChange={(e) => {
                        setSearch(e.target.value);
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Table
                loading={isLoading}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                  ...paginationParams,
                  total: totalCount,
                  onChange: (page, pageSize) => {
                    setPaginationParams({
                      currentPage: page,
                      pageSize: pageSize,
                    });
                  },
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      
    </>
  );
};

export default ListworkloadIdentites;
